import {ChangeDetectionStrategy, Component, Input, OnInit} from '@angular/core';
import {Route} from "@angular/router";
import {PermissionService} from "../../services/permission.service";

@Component({
  selector: 'tabs-route',
  templateUrl: './tabs-route.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class TabsRouteComponent implements OnInit {

  @Input() items: Route[] = [];

  constructor(public permissionService: PermissionService) { }

  ngOnInit(): void {
  }

}
